<template>
  <div>
    <h1 class="h3 mb-4 text-gray-800">{{ $t("guest_hub.title") }}</h1>

    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item">
        <a class="nav-link" href="javascript:void(0);" :class="{ 'active': show == 'general' }" @click="show = 'general'">
          {{ $t("guest_hub.nav_general") }}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link disabled" href="javascript:void(0);" aria-disabled="true" tabindex="-1">
          {{ $t("guest_hub.nav_display") }}</a>
      </li>
    </ul>
    <div class="tab-content">
      <general v-if="show == 'general'" />
      <display-tab v-if="show == 'display'" />
    </div>
  </div>
</template>

<script>
import General from "./general.vue";
import DisplayTab from "./display.vue";

export default {
  components: {
    General,
    DisplayTab,
  },
  data() {
    return {
      show: "general",
    };
  },
};
</script>
